import React, { useEffect, useRef, useState } from 'react';
import { AddSessionRequest, SessionDetails } from '../models/api';
import Button from './Button';
import Feedback from './Feedback';
/*import { useLanguages } from '../hooks/useLanguages';
import { list } from '../services/team.service';*/

type SessionDetailsFormProps = {
  model: SessionDetails | null | undefined;
  submit: (e: AddSessionRequest) => Promise<boolean>;
  isSubmitting: boolean;
  errors: string[];
  close: () => void;
  buttonText: string;
};

const SessionDetailsForm: React.FC<SessionDetailsFormProps> = ({
  model,
  submit,
  isSubmitting,
  errors,
  close,
  buttonText
}) => {
  const [addName, setAddName] = useState(model?.name ?? '');
  const [addAllowUserNavigation, setAddAllowUserNavigation] = useState(
    model?.allowUserNavigation ?? true
  );
  const [addAllowViewAllPages, setAddAllowViewAllPages] = useState(
    model?.allowViewAllPages ?? false
  );

  const nameInputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (nameInputRef.current) {
      nameInputRef.current.focus();
    }
  }, []);

  /*const [isTour, setIsTour] = useState(model?.isTour ?? false);
  const [language, setLanguage] = useState(model?.defaultLanguageCode ?? '');
  const [teamReference, setTeamReference] = useState(
    model?.teamReference ?? ''
  );
  const [teams, setTeams] = useState<TeamResponse[] | null>(null);

  const isOwner = !model || model.isOwner;

  const languages = useLanguages();

  const getTeams = async () => {
    const teamsResponse = await list();
    if (teamsResponse.success) {
      setTeams(teamsResponse.data?.teams || []);
    }
  };

  useEffect(() => {
    if (isOwner) {
      getTeams();
    }
  }, []);*/

  const handle = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const result = await submit({
      name: addName,
      allowUserNavigation: addAllowUserNavigation,
      allowViewAllPages: addAllowViewAllPages,
      isTour: false,
      defaultLanguageCode: null,
      teamReference: null
    });

    if (result) {
      setAddName('');
      setAddAllowUserNavigation(true);
      setAddAllowViewAllPages(false);
      /*setIsTour(false);
      setTeamReference('');*/
    }
  };

  return (
    <form onSubmit={handle} className="content-form">
      <input
        ref={nameInputRef}
        type="text"
        placeholder="Name"
        required
        value={addName}
        onChange={(e) => setAddName(e.target.value)}
      />
      <div className="checkbox-container">
        <input
          type="checkbox"
          id="addAllowUserNavigation"
          checked={addAllowUserNavigation}
          onChange={(e) => setAddAllowUserNavigation(e.target.checked)}
        />
        <label htmlFor="addAllowUserNavigation">Allow User Navigation</label>
      </div>
      <div className="checkbox-container">
        <input
          type="checkbox"
          id="addAllowViewAllPages"
          checked={addAllowViewAllPages}
          onChange={(e) => setAddAllowViewAllPages(e.target.checked)}
        />
        <label htmlFor="addAllowViewAllPages">Allow View All Pages</label>
      </div>
      {/*
      <div className="checkbox-container">
        <input
          type="checkbox"
          id="isTour"
          checked={isTour}
          disabled
          title="This functionality is not yet available"
          onChange={(e) => setIsTour(e.target.checked)}
        />
        <label htmlFor="isTour">Is Tour</label>
      </div>
      {languages.length > 0 && (
        <select
          id="languageSelect"
          value={language}
          onChange={(e) => setLanguage(e.target.value)}
        >
          <option value="">Select a language</option>
          {languages.map((language) => (
            <option key={language.code} value={language.code}>
              {language.displayName}
            </option>
          ))}
        </select>
      )}
      {languages.length === 0 && (
        <select
          id="languageSelect"
          value={language}
          onChange={(e) => setLanguage(e.target.value)}
          disabled
        >
          <option value="">Loading languages...</option>
        </select>
      )}
      {isOwner && teams && teams.length > 0 && (
        <select
          id="teamSelect"
          value={teamReference}
          onChange={(e) => setTeamReference(e.target.value)}
        >
          <option value="">Select a team</option>
          {teams.map((team) => (
            <option key={team.reference} value={team.reference}>
              {team.name}
            </option>
          ))}
        </select>
      )}
      {isOwner && teams === null && (
        <select
          id="teamSelect"
          value={teamReference}
          onChange={(e) => setTeamReference(e.target.value)}
          disabled
        >
          <option value="">Loading teams...</option>
        </select>
      )}
      {!isOwner && model && (
        <label>
          <select id="teamSelect" disabled>
            <option value="">{model.teamName}</option>
          </select>
        </label>
      )}
        */}
      <div className="button-container">
        <Button
          className="action-button"
          isLoading={isSubmitting}
          isSubmit={true}
        >
          {buttonText}
        </Button>
        <Button type="Outline" onClick={() => close()}>
          Cancel
        </Button>
      </div>
      <Feedback messages={errors} type="error" />
    </form>
  );
};

export default SessionDetailsForm;
